import { useCogniteClient } from '#core/hooks/useCogniteClient.ts';

import { useSessionTimeseries } from '#plugin-chat';

/**
 * The shared acquisition prelude for the enriched-catalog hooks: the CDF client
 * the FlatHierarchy / Entity reads run through, plus the session timeseries
 * minter (`useSessionTimeseries().buildSource`) every per-row timeseries cell is
 * built through. Both hook calls are unconditional, so every enriched-catalog
 * hook threads the same pair into its `createEnrichedView` / `createFlattenedView`
 * specs.
 */
export const useCatalogEnrichContext = () => {
  const client = useCogniteClient();
  const mintSeries = useSessionTimeseries().buildSource;
  return { client, mintSeries };
};
